import { render } from "./secondaryButton.vue?vue&type=template&id=f1939d56"
import script from "./secondaryButton.vue?vue&type=script&lang=js"
export * from "./secondaryButton.vue?vue&type=script&lang=js"

import "./secondaryButton.vue?vue&type=style&index=0&id=f1939d56&lang=css"

import exportComponent from "/Users/matjeez/Matjez/Projects/websites/simonkr-feb24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__